/**
 * Wizard-internal state types.
 *
 * API contract types live in `@/services/api/offlineConversions` and are the
 * single source of truth shared between the form (Zod) and the backend
 * (Pydantic). This file only contains wizard-specific UI state.
 */
import type {
  Consent,
  ConversionActionSummary,
  ECLPreflightResult,
  OfflineConversionEvent,
} from '@/services/api/offlineConversions';

export type Step =
  | 'preflight'
  | 'pick-action'
  | 'consent'
  | 'input'
  | 'upload'
  | 'results';

export type InputMethod = 'single' | 'csv';

export interface WizardState {
  step: Step;
  conversionAction: ConversionActionSummary | null;
  preflight: ECLPreflightResult | null;
  consent: Consent;
  inputMethod: InputMethod;
  /** Hashed-PII events ready to send. Empty until input step completes. */
  events: OfflineConversionEvent[];
  /** Surfaces from CSV parser; per-row rejections we caught client-side. */
  parseRejections: Array<{ rowIndex: number; field?: string; reason: string }>;
  requestId: string | null;
}

export const initialWizardState: WizardState = {
  step: 'preflight',
  conversionAction: null,
  preflight: null,
  consent: {
    ad_user_data: 'CONSENT_STATUS_UNSPECIFIED',
    ad_personalization: 'CONSENT_STATUS_UNSPECIFIED',
  },
  inputMethod: 'csv',
  events: [],
  parseRejections: [],
  requestId: null,
};
